import {Button, Card, CardBody, Col, Input, Row} from "reactstrap";
import {formatModifyDate} from "../../../components/Common/CommonLogic";
import React from "react";
import Skeleton from "react-loading-skeleton";


const SearchDetailsSkeleton = () => {
    return (
        <>
            <Card className="shadow rounded-4 p-3 mb-4">
                <CardBody>
                    <Row>
                        <Col md="3">
                            <h6 className="text-muted mb-1">Container:</h6>
                            <h5 className="fw-bold"><Skeleton height={20} /></h5>
                            <small>Container type: <Skeleton height={20} /></small>
                        </Col>
                        <Col md="3">
                            <h6 className="text-muted mb-1">From:</h6>
                            <div className="fw-bold"><Skeleton height={20} /></div>
                            <small><Skeleton height={20} /></small>
                        </Col>
                        <Col md="3">
                            <h6 className="text-muted mb-1">To:</h6>
                            <div className="fw-bold"><Skeleton height={20} /></div>
                            <small><Skeleton height={20} /></small>
                        </Col>
                        <Col md="3">
                            <h6 className="text-muted mb-1">Last status:</h6>
                            <div className="fw-bold"><Skeleton height={20} /></div>
                            <small><Skeleton height={20} /></small>
                            <br/>
                            <small><Skeleton height={20} /></small>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </>
    )
}

export default SearchDetailsSkeleton;